// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"59b4fe40","925":"f9b157b4","970":"08896643"}[chunkId] + ".chunk.js";
};